import React from 'react';
import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons';
import { instHotspotSearchStyle } from './Config';

export function InstHotspotSearchBar({
  value,
  onChange,
  onSearch,
  onClear,
}: {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onClear: () => void;
}) {
  const s = instHotspotSearchStyle;

  return (
    <div
      className="lf-inst-hotspot-search-bar"
      style={{
        maxWidth: s.maxWidth,
        height: s.height,
        borderRadius: s.borderRadius,
        backgroundColor: s.inputBackgroundColor,
      }}
    >
      <input
        className="lf-inst-hotspot-search-bar__input"
        value={value}
        placeholder={s.placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onSearch();
          }
        }}
        style={{
          color: s.textColor,
        }}
      />
      {value ? (
        <button
          type="button"
          className="lf-inst-hotspot-search-bar__icon-btn"
          aria-label="清除"
          onClick={onClear}
          style={{ color: s.iconColor }}
        >
          <CloseCircleFilled />
        </button>
      ) : null}
      <button
        type="button"
        className="lf-inst-hotspot-search-bar__icon-btn lf-inst-hotspot-search-bar__search-btn"
        aria-label="搜索"
        onClick={onSearch}
        style={{ color: s.iconColor }}
      >
        <SearchOutlined />
      </button>
    </div>
  );
}
